import { useEffect } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { MarketingLayout } from "@/components/marketing/MarketingLayout";
import { MarketingHomePage } from "@/pages/marketing/HomePage";
import { MarketingHowPage } from "@/pages/marketing/HowPage";
import { MarketingPricingPage } from "@/pages/marketing/PricingPage";
import { MarketingAboutPage } from "@/pages/marketing/AboutPage";
import { MarketingContactPage } from "@/pages/marketing/ContactPage";
import { MarketingLegalPage } from "@/pages/marketing/LegalPage";

function NotFoundPage() {
  return (
    <MarketingLayout>
      <section className="how-hero" data-testid="public-notfound-page">
        <div className="wrap">
          <span className="eyebrow">404</span>
          <h1 className="headline" data-testid="public-notfound-title">Page not found</h1>
          <p className="sub" data-testid="public-notfound-body">The page you were looking for does not exist.</p>
          <div className="hero-cta" style={{ marginTop: 28 }}>
            <Link className="btn btn-primary" to="/" data-testid="public-notfound-signup-button">Return home</Link>
            <Link className="btn btn-ghost" to="/oak-and-ember" data-testid="public-notfound-storefront-button">Sample storefront</Link>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}

function HomeWithHash() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
    return () => window.clearTimeout(timer);
  }, [location.hash]);
  return <MarketingHomePage />;
}

export function PublicSite({ page }) {
  if (page === "features") {
    return <Navigate to={{ pathname: "/", hash: "how" }} replace />;
  }

  switch (page) {
    case "home":
      return <HomeWithHash />;
    case "how":
      return <MarketingHowPage />;
    case "pricing":
      return <MarketingPricingPage />;
    case "about":
      return <MarketingAboutPage />;
    case "contact":
      return <MarketingContactPage />;
    case "terms":
      return <MarketingLegalPage docKey="terms" />;
    case "privacy":
      return <MarketingLegalPage docKey="privacy" />;
    case "cookies":
      return <MarketingLegalPage docKey="cookies" />;
    case "refund":
      return <MarketingLegalPage docKey="refund" />;
    case "impressum":
      return <MarketingLegalPage docKey="impressum" />;
    case "dpa":
      return <MarketingLegalPage docKey="dpa" />;
    case "notfound":
      return <NotFoundPage />;
    default:
      return <NotFoundPage />;
  }
}
